
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue"
import UsersContent from "./components/UsersContent.vue";


export default defineComponent({
  name: "UsersPage",
  components: {
    BreadCrumb,
    UsersContent
},
});
